import {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'

const Unauthenticated = () => {
  const navigate = useNavigate()
  useEffect(() => {
    navigate('/login')
  }, [])
  return null
}

export default Unauthenticated
